<template>
    <div>
        <div v-for="box in boxes">
            <box :active="box.active" :id="box.id">
                <h5 class="title" slot="title">{{box.name}}<span @click="close(box)" class="close">x</span></h5>
                <div class="content" slot="content" v-html="buildBoxContent(box)"></div>
            </box>
        </div>
    </div>
</template>
<script>
    import Box from './box/Box.vue'
    export default {
        name: 'HoverBoxes',
        props: [
            'boxes',
        ],
        components: {
            Box
        },
        data () {
            return {
            }
        },
        methods: {
            buildBoxContent (box) {
                let content = '<p>'
                if (box.email || box.address || box.phone) {
                    content = content +'<br>'
                }
                if (box.email) {
                    content = content + box.email + '<br>'
                }
                if (box.address) {
                    content = content + box.address + '<br>'
                }
                if (box.phone) {
                    content = content + box.phone + '<br>'
                }

                content = content + '</p>'

                return content
            },
            close (box){
                this.$emit("close-box", box)
            }
        }
    }
</script>
<style>
  .close {
    color: #fff;
    opacity: .8;
    padding: 0 5px 0 0;
}

.close:hover {
    color: #fff;
    opacity: 1;
}
/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {

}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {

}

/* // Medium devices (tablets, 768px and up) */
@media (max-width: 768px) {

}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) {

}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>


// WEBPACK FOOTER //
// src/components/coverage/HoverBoxes.vue